import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';

@Injectable()
export class InvitationService {
  private oauthUrl: string = environment.idam_api_url + '/oauth2';

  constructor(private _http: HttpClient) {
  }

  public checkInvitationLink(invitationId: any, token: any): Observable<HttpResponse<any>> {
    try {
      const url: string = `${this.oauthUrl}/invitation-link/invitation/${invitationId}/recipient/${token}/check?tenant=tenant1`;
      return this._http.post(url, null, {observe: 'response'});
    }
    catch(error) {
      throw error;
    }
  }

  public getAllSignUpFieldsByInvitationId(invitationId: any): Observable<any> {
    const url: string = `${this.oauthUrl}/${invitationId}/getSignUpFields?tenant=tenant1`;
    return this._http.get(url);
  }

  public storeSignUpFieldsValues(signUpRecipientPayload: any): Observable<HttpResponse<any>> {
    try {
      const url: string = `${this.oauthUrl}/store/signup-fields-recipient?tenant=tenant1`;
      return this._http.post<any>(url, signUpRecipientPayload);
    }
    catch(error) {
      return error;
    }
  }

}
